import { Box, Button, TextField, Typography } from "@mui/material"
import { useState } from "react"

export default function UnitPage() {
  const main = 1758
  const md = 1358 / main
  const sm = 958 / main
  const xs = 600 / main

  const [val, setVal] = useState([])

  const addNew = () => {
    val.push(0)
    setVal([...val])
  }

  const handleChange = (e, i) => {
    val[i] = e.target.value
    setVal([...val])
  }

  return (
    <Box>
      <Button onClick={addNew}>Add </Button>

      {val.map((item, i) => (
        <Box>
          <TextField onChange={(e) => handleChange(e, i)} />
          <Typography>
            {`{`}xs:"{(val[i] * xs).toFixed(0)}px", sm:"{(val[i] * sm).toFixed(0)}px", md:"{(val[i] * md).toFixed(0)}px"{`}`}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}
